export default {
    All:"Multiple"

    
};